import { FC, useCallback } from 'react'
import { Row, Col, CardBlog, HorizontalScroll } from '@/client/components'
import { useWindowSize } from '@/client/hooks'
import { SliderArrow } from '@/client/submodules/Slider'
import * as S from './styles'
import { PressListProps } from '../types'

const settings = {
  speed: 500,
  infinite: false,
  prevArrow: <SliderArrow position='left' slidesToShow={3} />,
  nextArrow: <SliderArrow position='right' slidesToShow={3} />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 99999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
}

export const PressList: FC<PressListProps> = ({ press }) => {
  const windowSize = useWindowSize()
  const isLgBreakpoint = windowSize?.width > 768

  const pressList = useCallback(
    () =>
      press.map(({ link, image, title, description, tags }) => (
        <S.CardBlogWrapper key={title}>
          <CardBlog
            href={link}
            image={image}
            tags={tags}
            title={title}
            description={description}
            buttonLabel='Continue reading'
          />
        </S.CardBlogWrapper>
      )),
    [press]
  )

  return (
    <S.PressList>
      <Row>
        <Col xs={12}>
          {!isLgBreakpoint && <HorizontalScroll>{pressList()}</HorizontalScroll>}
          {isLgBreakpoint && <S.Slide {...settings}>{pressList()}</S.Slide>}
        </Col>
      </Row>
    </S.PressList>
  )
}
